module.exports = __webpack_public_path__ + "img/ryjks7.b61ab1c7.png";